/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:taxIdValidator
 * @restrict A
 * @param    {string=} taxIdValidator   Error popup title.
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} disableValidator "true"=skip validation.
 *
 * @description
 * Validator to verify a valid SS#/EIN.
 **/
/* @ngInject */ export function taxIdValidator(CSMValidatorService) {
  var RE_TAX = /^(\d{2}-\d{7})|(\d{3}-\d{2}-\d{4})$/;

  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      var error = CSMValidatorService.BaseValidator.prototype.doValidate.call(
        this,
        value
      );
      return (
        error ||
        (value && !RE_TAX.test(value)
          ? 'This is not a valid Federal EIN or Social Security Number'
          : null)
      );
    }
  });
}
